// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__QTF8X","col":"styles_col__ZcwDp","fulfillmentStatus":"styles_fulfillmentStatus__122QY","emailCol":"styles_emailCol__3m9-W"};